const dotComRegisterTypes = {
  '/alternative-investments': 'alternative-investments',
  '/analyst': 'analyst-ratings',
  '/author': 'author-page',
  '/calendars': 'calendars',
  '/cannabis': 'cannabis',
  '/crypto': 'crypto',
  '/markets': 'markets',
  '/money': 'money',
  '/news': 'news',
  '/profile/portfolio': 'portfolio',
  '/research': 'research',
  '/sec/insider-trades': 'insiders',
  '/topic': 'newspage',
  '/trading-ideas': 'trading-ideas',
  '/yield-investments': 'yield-investments',
};

const quotePageRegisterTypes = {
  '/analyst-ratings': 'quote-page-analyst-ratings',
  '/dividends': 'quote-page-dividends',
  '/earnings': 'quote-page-earnings',
  '/guidance': 'quote-page-guidance',
  '/ideas': 'quote-page-ideas',
  '/insider-trades': 'quote-page-insider-trades',
  '/news': 'quote-page-news',
  '/short-interest': 'quote-page-short-interest',
};

export const getRegisterType = (routeAsPath: string) => {
  let register_type = 'homepage';

  if (routeAsPath.startsWith('/quote')) {
    register_type = 'quote';
    for (const registerType in quotePageRegisterTypes) {
      if (routeAsPath.includes(registerType)) {
        register_type = quotePageRegisterTypes[registerType];
        break;
      }
    }
  } else {
    for (const registerType in dotComRegisterTypes) {
      if (routeAsPath.startsWith(registerType)) {
        register_type = dotComRegisterTypes[registerType];
        break;
      }
    }
  }

  return register_type;
};

export default getRegisterType;
